module.exports = __webpack_public_path__ + "static/media/important.0f8205dc.png";